<label class="radio-button">
  <ng-content select="input"></ng-content>
  <span class="radio-button__decor"></span>
  <span class="radio-button__label">
    <ng-content select="radio-button-text"></ng-content>
  </span>
</label>
